// extracted by mini-css-extract-plugin
export default {"banner":"BannerCarousel_banner__P-IIY","slide":"BannerCarousel_slide__bfl3S","img":"BannerCarousel_img__ApN2T"};